import Icon from '../components/Icon.vue'

Icon.register({
  'angle-double-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-96.3 96.5 96.4 96.4c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.7c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-0.1-34zM31.7 273c-9.4-9.4-9.4-24.6 0.1-34l136-136c9.3-9.4 24.5-9.4 33.9 0l22.6 22.7c9.4 9.3 9.4 24.5 0 33.9l-96.4 96.4 96.3 96.5c9.4 9.3 9.4 24.5 0 33.9l-22.6 22.6c-9.3 9.4-24.5 9.4-33.9 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-left.js
// module id = 603
// module chunks = 0